<template>
  <v-layout text-center wrap class="loading-container">
    <v-flex xs12 class="d-flex align-center justify-center">
      <!-- <div
        class="loading"
        :style="`background-image: url('${require('@/assets/loading.svg')}')`"
      ></div> -->
      <img :src="require('@/assets/loading.svg')" class="loading" />
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'LoadingScreen',
  data: () => ({}),
  mounted() {},
  methods: {},
  computed: {}
};
</script>
<style lang="scss" scoped>
.loading-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
  background-color: rgba(255, 255, 255, 0.4);
}

.loading {
  // position: absolute;
  width: 100px;
  height: 100px;
  animation: animate 2s linear infinite;
}

@keyframes animate {
  0% {
    //background-position: 0 0px;
    // top: calc(100vh / 2 - 50px);
    clip-path: inset(100% 0 0 0);
  }

  50% {
    // background-position: 0 -100px;
    // top: calc(100vh / 2 + 50px);
    clip-path: inset(0 0 0 0);
  }

  100% {
    //background-position: 0 0px;
    // top: calc(100vh / 2 - 50px);
    clip-path: inset(100% 0 0 0);
  }
}
</style>
